import React, { useState, useEffect, useRef } from 'react'
import CoachMark from './CoachMark'
import { arMatyta, pazymetiMatyta } from '../utils/onboarding'

// Meniu punktų ikonos (stroke, kaulo/rūko spalva)
const IKONOS = {
  paskyra: <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></>,
  issaugotos: <path d="M19 21l-7 -5 -7 5V5.2c0 -1.2 0.9 -2.2 2 -2.2h10c1.1 0 2 1 2 2.2z" />,
  issukiai: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1.4" /></>,
  nustatymai: <><circle cx="12" cy="12" r="3" /><path d="M12 1v6M12 17v6M4.22 4.22l4.24 4.24M15.54 15.54l4.24 4.24M1 12h6M17 12h6M4.22 19.78l4.24-4.24M15.54 8.46l4.24-4.24" /></>,
  kalba: <><circle cx="12" cy="12" r="10" /><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></>,
  prenumerata: <><rect x="1" y="4" width="22" height="16" rx="2" /><path d="M1 10h22" /></>,
  pagalba: <><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17h.01" /></>,
  pakviesk: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M19 8v6M22 11h-6" /></>,
  tobulinti: <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />,
}

const CHEVRON = (
  <svg className="chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: 'auto', opacity: 0.4 }}>
    <path d="M9 18l6-6-6-6" />
  </svg>
)

function MeniuPunktas({ ikona, tekstas, priedas, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 10px', color: '#F0E8D5', fontSize: '13px', cursor: 'pointer', borderRadius: '8px', background: 'transparent', border: 'none', width: '100%', textAlign: 'left', fontFamily: 'Syne, system-ui, sans-serif', transition: 'background 150ms ease' }}
      onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(240,232,213,0.04)' }}
      onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent' }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7A8A7E" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
        {ikona}
      </svg>
      <span>{tekstas}</span>
      {priedas && <span style={{ color: '#7A8A7E', fontSize: '11px', marginLeft: '6px' }}>· {priedas}</span>}
      {CHEVRON}
    </button>
  )
}

function ProfilioLentele({ atidaryta, onClose, onIssaugotos, onIssukiai, onNustatymai, onKalba, onPrenumerata, onPagalba, onPakviesk, onPadekTobulinti, onPaskyra }) {
  const issukiaiRef = useRef(null)
  const [coachRodyti, setCoachRodyti] = useState(false)

  useEffect(() => {
    if (atidaryta && !arMatyta('ob_issukiai')) {
      const t = setTimeout(() => setCoachRodyti(true), 480)
      return () => clearTimeout(t)
    }
    setCoachRodyti(false)
  }, [atidaryta])

  return (
    <>
      {/* Scrim — paspaudus šalia uždaro */}
      <div
        onClick={onClose}
        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, opacity: atidaryta ? 1 : 0, pointerEvents: atidaryta ? 'auto' : 'none', transition: 'opacity 400ms cubic-bezier(0.32,0.72,0,1)' }}
      />

      {/* Drawer */}
      <div style={{ position: 'fixed', top: 0, right: 0, bottom: 0, width: '300px', maxWidth: '85%', background: '#1E2E27', borderLeft: '1px solid #2A3B32', zIndex: 1001, transform: atidaryta ? 'translateX(0)' : 'translateX(100%)', transition: 'transform 400ms cubic-bezier(0.32,0.72,0,1)', display: 'flex', flexDirection: 'column', padding: '20px' }}>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '24px' }}>
          <div>
            <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: 'rgba(229,168,64,0.14)', border: '1px solid rgba(229,168,64,0.4)', color: '#E5A840', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Lora', Georgia, serif", fontSize: '22px', fontWeight: 500 }}>
              I
            </div>
            <p style={{ color: '#F0E8D5', fontSize: '14px', fontWeight: 500, margin: '12px 0 0' }}>Ignas</p>
            <p style={{ color: '#7A8A7E', fontSize: '11px', margin: '2px 0 0' }}>svečias · išsaugota lokaliai</p>
          </div>
          <button
            onClick={onClose}
            aria-label="Uždaryti"
            style={{ width: '32px', height: '32px', borderRadius: '50%', background: 'transparent', border: '1px solid #3A4C42', color: '#F0E8D5', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6L6 18M6 6l12 12" /></svg>
          </button>
        </div>

        {/* Meniu */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <MeniuPunktas ikona={IKONOS.paskyra} tekstas="Paskyra" onClick={onPaskyra} />
          <MeniuPunktas ikona={IKONOS.issaugotos} tekstas="Išsaugotos vietos" onClick={onIssaugotos} />
          <div ref={issukiaiRef}>
            <MeniuPunktas ikona={IKONOS.issukiai} tekstas="Iššūkiai" onClick={onIssukiai} />
          </div>
          <MeniuPunktas ikona={IKONOS.nustatymai} tekstas="Nustatymai" onClick={onNustatymai} />
          <MeniuPunktas ikona={IKONOS.kalba} tekstas="Kalba" priedas="LT" onClick={onKalba} />
          <MeniuPunktas ikona={IKONOS.prenumerata} tekstas="Prenumerata" onClick={onPrenumerata} />
          <MeniuPunktas ikona={IKONOS.pakviesk} tekstas="Pakviesk draugą" onClick={onPakviesk} />
          <MeniuPunktas ikona={IKONOS.tobulinti} tekstas="Padėk tobulinti" onClick={onPadekTobulinti} />
          <MeniuPunktas ikona={IKONOS.pagalba} tekstas="Pagalba ir DUK" onClick={onPagalba} />
        </div>
      </div>

      {coachRodyti && (
        <CoachMark
          targetRef={issukiaiRef}
          antraste="Iššūkiai"
          tekstas="Čia — iššūkiai su tikslais. Užsuk retkarčiais: įveikti duoda ženkliukų ir kelia lygį."
          paskutinis
          onKitas={() => { pazymetiMatyta('ob_issukiai'); setCoachRodyti(false) }}
        />
      )}
    </>
  )
}

export default ProfilioLentele
